import mutations from './periodicAptitudeTest.mutations'
import actions from './periodicAptitudeTest.actions'
import getters from './periodicAptitudeTest.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
